import { TableCell, TableHead, TableRow, TableSortLabel, Tooltip } from '@material-ui/core'
import InfoIcon from '@mui/icons-material/Info'
import PropTypes from 'prop-types'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(() => ({
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    headLabelWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    infoIcon: {
        cursor: 'pointer',
        color: '#ff2c46',
    },
    infoTooltip: {
        maxWidth: '320px',
        fontSize: '13px',
        padding: '10px 12px',
        lineHeight: 1.4
    },
}))
EnhancedTableHead.propTypes = {
    sort: PropTypes.string,
    headCells: PropTypes.array.isRequired,
}
export default function EnhancedTableHead(props) {
    const { setField,setSort, headCells, sort} = props
    const classes = useStyles();

    return (
        <TableHead>
            <TableRow>
                {headCells.filter(cell => !cell?.hideRow).map((headCell) =>
 		            headCell.label  &&
                        <TableCell
                            key={headCell.id}
                            align='center' 
                            >
                            <div className={classes.headLabelWrapper}>
                            <TableSortLabel
                                direction={sort}
                                hideSortIcon={headCell.hideSort}
                                onClick={() => {
                                    if(!headCell.hideSort){
                                        setSort((prev) => prev == 'asc' ? 'desc' : 'asc');
                                        setField(headCell.id);
                                    }
                                }}>
                                {headCell.label}
                            </TableSortLabel>
                              {headCell.info && (
                                <Tooltip
                                arrow
                                title={headCell.info}
                                placement="top"
                                classes={{ tooltip: classes.infoTooltip }}
                                >
                                <InfoIcon
                                    className={classes.infoIcon}
                                    fontSize="small"
                                />
                                </Tooltip>
                            )}
                            </div>
                        </TableCell>
                )}
            </TableRow>
        </TableHead>
    )
}